module.exports = __webpack_public_path__ + "img/ug421.9bc34d4e.png";